<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent :fullscreen="$vuetify.breakpoint.xsOnly" transition="fade-transition" max-width="600px")
    v-card
      v-card-title.px-5
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="closeEdit" height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.basic800--text {{ $t('edit_sales_page') }}

      v-card-text.pt-4.pb-16.px-5
        v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        template(v-else)
          v-row(no-gutters align="center")
            v-col
              div.h5.basic800--text {{ form.name }}
            v-col.shrink(v-if="member.role === 'Admin'")
              v-btn(icon small @click="openPageNameDialog = true")
                eva-icon(name="edit-2" :fill="$vuetify.theme.themes[$theme].primary400" height="20" width="20" style="margin-bottom: -6px")
          div.mt-2
            a.p1.info500--text(v-if="Auth('root', 'custom_link') && customlinkSlug" @click="openLink(getShareCustomURL())") {{ getShareCustomURL() }}
            a.p1.info500--text(v-else @click="openLink(getBrandedLinkURL())") {{ getBrandedLinkURL() }}
          v-row.mt-4(no-gutters)
            v-col.pr-1
              v-btn.button-AA-small(color="primary" small outlined depressed block height="32" style="background-color: var(--v-basic600T08)" @click="openPageLinkDialog = true") {{ $t('edit_link') }}
            v-col.pl-1
              v-btn.button-AA-small(color="primary" small outlined depressed block height="32" style="background-color: var(--v-basic600T08)" @click="clickShare") {{ $t('share') }}

          template(v-if="member.role === 'Admin'")

            //- 1ST SECTION
            div.s2.primary400--text.mt-6 {{ $t('customize_your_page') }}
            div.mt-2(style="border:1px solid var(--v-basic400); border-radius: 4px;")
              div.pa-4
                div(@click="openEditPageDialog = true")
                  div.d-flex.align-center
                    eva-icon.mr-4(name="edit-2" width="22" height="22" :fill="$vuetify.theme.themes[$theme].primary" style="margin-bottom: -6px")
                    div.p1.primary--text {{ $t('edit_page_content') }}
                    v-spacer
                    eva-icon.mb-n2(name="chevron-right-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary")
              v-divider.basic400
              div.pa-4
                div(@click="openDataCollectionDialog = true")
                  div.d-flex.align-center
                    eva-icon.mr-4(name="clipboard" width="22" height="22" :fill="$vuetify.theme.themes[$theme].primary" style="margin-bottom: -6px")
                    div.p1.primary--text {{ $t('data_collection') }}
                    v-spacer
                    eva-icon.mb-n2(name="chevron-right-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary")

            //- 2ND SECTION
            div.s2.primary400--text.mt-6 {{ $t('products_and_order') }}
            div.mt-2(style="border:1px solid var(--v-basic400); border-radius: 4px;")
              div.pa-4
                div(@click="openAttachProductnDialog = true")
                  div.d-flex.align-center
                    eva-icon.mr-4(name="cube" width="22" height="22" :fill="(form.products && form.products.length > 0) ? 'var(--v-primary)' : 'var(--v-danger600)'" style="margin-bottom: -6px")
                    div.p1(:class="(form.products && form.products.length > 0) ? 'primary--text' : 'danger600--text'") {{ $t('attach_products') }}
                    v-spacer
                    eva-icon.mb-n2(name="chevron-right-outline" width="24" height="24" :fill="(form.products && form.products.length > 0) ? 'var(--v-primary)' : 'var(--v-danger600)'")
              v-divider.basic400
              div.pa-4
                div(@click="openFormTypeDialog = true")
                  div.d-flex.align-center
                    eva-icon.mr-4(name="credit-card" width="22" height="22" :fill="$vuetify.theme.themes[$theme].primary" style="margin-bottom: -6px")
                    div.p1.primary--text {{ $t('what_customer_can') }}
                    v-spacer
                    eva-icon.mb-n2(name="chevron-right-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary")

            //- 3RD SECTION
            div.s2.primary400--text.mt-6 {{ $t('settings') }}
            div.mt-2(style="border:1px solid var(--v-basic400); border-radius: 4px;")
              div.pa-4
                div(@click="openSalesPersonDialog = true")
                  div.d-flex.align-center
                    eva-icon.mr-4(name="person" width="22" height="22" :fill="(form.members && form.members.length > 0) ? 'var(--v-primary)' : 'var(--v-danger600)'" style="margin-bottom: -6px")
                    div.p1(:class="(form.members && form.members.length > 0) ? 'primary--text' : 'danger600--text'") {{ $t('whos_selling') }}
                    v-spacer
                    eva-icon.mb-n2(name="chevron-right-outline" width="24" height="24" :fill="(form.members && form.members.length > 0) ? 'var(--v-primary)' : 'var(--v-danger600)'")
              v-divider.basic400
              template(v-if="zones.length > 0")
                div.pa-4
                  div(@click="openFormZonesDialog = true")
                    div.d-flex.align-center
                      eva-icon.mr-4(name="car" width="22" height="22" :fill="$vuetify.theme.themes[$theme].primary" style="margin-bottom: -6px")
                      div.p1.primary--text {{ $t('manage_shipping_zones') }}
                      v-spacer
                      eva-icon.mb-n2(name="chevron-right-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary")

      .modals
        edit-landing-page-name(v-if="openPageNameDialog" :open.sync="openPageNameDialog" :parentForm.sync="form")
        edit-landing-page-link(v-if="openPageLinkDialog" :open.sync="openPageLinkDialog" :parentForm.sync="form" :company="company" @updated="fetchCustomLink")
        edit-landing-page-content(v-if="openEditPageDialog" :open.sync="openEditPageDialog" :parentForm.sync="form" :company="company")
        edit-landing-data-collection(v-if="openDataCollectionDialog" :open.sync="openDataCollectionDialog" :parentForm.sync="form")
        edit-landing-attach-products(v-if="openAttachProductnDialog" :open.sync="openAttachProductnDialog" :parentForm.sync="form")
        edit-landing-form-type(v-if="openFormTypeDialog" :open.sync="openFormTypeDialog" :parentForm.sync="form")
        edit-landing-sales-person(v-if="openSalesPersonDialog" :open.sync="openSalesPersonDialog" :parentForm.sync="form")
        edit-landing-shipping-zones(v-if="openFormZonesDialog" :open.sync="openFormZonesDialog" :parentForm.sync="form" :zones="zones" :company="company")
        edit-landing-meta-data(v-if="openMetaDataDialog" :open.sync="openMetaDataDialog" :parentForm.sync="form")

        //- SHARE
        y-bottom-sheet(v-model='shareSheet' inset max-width="600px")
          v-card.py-4(flat)
            div.mx-6.s2.primary400--text {{ $t('share_url_by') }}
            v-list.pa-0
              v-list-item(@click="shareUrlToSocial('whatsapp')")
                v-list-item-avatar.my-0
                  v-icon(color="#455A64" size="24") fab fa-whatsapp
                v-list-item-title.s2.basic1000--text {{ $t('whatsapp') }}
              v-list-item(@click="shareUrlToSocial('facebook')")
                v-list-item-avatar.my-0
                  v-icon(color="#3b5998" size="24") fab fa-facebook
                v-list-item-title.s2.basic1000--text {{ $t('facebook') }}
              v-list-item(v-if="Auth('root', 'custom_link') && customlinkSlug" @click="copyUrl('custom', getShareCustomURL())")
                v-list-item-avatar.my-0
                  v-icon(size="24") mdi-content-copy
                v-list-item-title.s2.basic1000--text {{ $t('copy_custom_link') }}
                  div.c1.primary400--text {{getShareCustomURL()}}
              v-list-item(@click="copyUrl('branded', getBrandedLinkURL())")
                v-list-item-avatar.my-0
                  v-icon(size="24") mdi-content-copy
                v-list-item-title.s2.basic1000--text {{ $t('copy_link') }}
                  div.c1.primary400--text(ref="branded") {{getBrandedLinkURL()}}
              v-list-item(@click="copyUrl('short', getShortLinkURL())")
                v-list-item-avatar.my-0
                  v-icon(size="24") mdi-content-copy
                v-list-item-title.s2.basic1000--text {{ $t('copy_short_link') }}
                  div.c1.primary400--text(ref="short") {{getShortLinkURL()}}
              v-list-item(@click="openPrintQR = true")
                v-list-item-avatar.my-0
                  v-icon(size="24") mdi-qrcode
                v-list-item-title.s2.basic1000--text {{ $t('print_qr_code') }}

        //- QRCODE
        y-dialog.white(v-model='openPrintQR' max-width="400px")
          v-card
            v-row.pt-3(no-gutters align="center")
              v-col(cols="8" offset="2" align="center")
                v-chip(color="black" :to="`/print-qr?link=${form.slug}`" target="_blank" link outlined small)
                  | {{ $t('print') }}
                  v-icon.ml-2(small) mdi-cloud-print-outline
              v-col.pr-3(cols="2" align="center")
                v-btn(icon small @click="openPrintQR = false; shareSheet = false")
                  v-icon mdi-close
            v-card(align="center" flat)
              div.d-flex.justify-center.align-center(style="position: absolute; height: 100%; width: 100%")
                img(:src="require('@/assets/images/icon_yezza_qr.png')" style="width: 75px")
              vue-qrcode(:value="getQRLinkURL()" :options="{ width: 270 }")

        //- GENERATING
        y-dialog(v-model='generatingShareUrl', hide-overlay persistent width='300')
          v-card(color='primary' dark)
            v-card-text.pt-3
              | {{ $t('generation_share_url') }}
              v-progress-linear.mb-0.mt-2(indeterminate color='white')

</template>

<script>
import { mapActions, mapState } from 'vuex'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import LandingPageEditor from '@/components/localads/LandingPageEditor.vue'
import ProductManagement from '@/components/localads/ProductManagement.vue'
import LandingFormType from '@/components/localads/LandingFormType.vue'
import LandingExtraField from '@/components/localads/LandingExtraField.vue'
import LandingSalesPerson from '@/components/localads/LandingSalesPerson.vue'
import EditLandingPageName from '@/components/dialogs/localads/EditLandingPageName.vue'
import EditLandingPageLink from '@/components/dialogs/localads/EditLandingPageLink.vue'
import EditLandingPageContent from '@/components/dialogs/localads/EditLandingPageContent.vue'
import EditLandingDataCollection from '@/components/dialogs/localads/EditLandingDataCollection.vue'
import EditLandingAttachProducts from '@/components/dialogs/localads/EditLandingAttachProducts.vue'
import EditLandingFormType from '@/components/dialogs/localads/EditLandingFormType.vue'
import EditLandingSalesPerson from '@/components/dialogs/localads/EditLandingSalesPerson.vue'
import EditLandingShippingZones from '@/components/dialogs/localads/EditLandingShippingZones.vue'
import EditLandingMetaData from '@/components/dialogs/localads/EditLandingMetaData.vue'

export default {
  name: 'EditLandingForm',
  props: ['open', 'company', 'parentForm'],
  components: {
    LandingPageEditor,
    ProductManagement,
    LandingFormType,
    LandingExtraField,
    LandingSalesPerson,
    EditLandingPageLink,
    EditLandingPageName,
    EditLandingPageContent,
    EditLandingDataCollection,
    EditLandingAttachProducts,
    EditLandingFormType,
    EditLandingSalesPerson,
    EditLandingShippingZones,
    EditLandingMetaData,
    VueQrcode,
  },
  data: () => ({
    isFetching: false,
    isLoading: false,
    step: 0,
    landingFormError: false,
    customlinkSlug: null,
    customDomainURL: null,
    openPageNameDialog: false,
    openPageLinkDialog: false,
    openEditPageDialog: false,
    openDataCollectionDialog: false,
    openAttachProductnDialog: false,
    openFormTypeDialog: false,
    openSalesPersonDialog: false,
    openFormZonesDialog: false,
    openMetaDataDialog: false,
    form: {},
    zones: [],
    shareSheet: false,
    openPrintQR: false,
    generatingShareUrl: false
  }),
  computed: {
    ...mapState('user', ['member']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    linkURL () {
      if (this.customDomainURL) {
        return `https://${this.customDomainURL}/`
      }
      return `https://${this.company.slug}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/`
    }
  },
  watch: {
  },
  mounted () {
    this.fetchForm()
    this.fetchDomain()
    this.fetchCustomLink()
    this.fetchZones()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchForm () {
      this.isFetching = true
      let url = `/forms/${this.parentForm.id}/`
      if (this.member.role === 'Agent') {
        url += `?agent_member_id=${this.member.id}`
      }
      this.$axios.get(url)
        .then((response) => {
          this.form = { ...response.data }
        })
        .catch(() =>{})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchCustomLink () {
      this.customlinkSlug = null
      let url = null
      url = this.member.role === 'Agent' ? `member=${this.member.id}` : 'without_member=true'
      this.$axios.get(`/forms/${this.parentForm.id}/slugs/?${url}`)
        .then(resp => {
          if (resp.data.results.length  > 0) {
            this.customlinkSlug = resp.data.results[0].slug
          }
        })
        .catch(() => {})
    },
    fetchDomain () {
      this.$axios.get(`/domains/?company=${this.company.id}`)
        .then((response) => {
          let domain = response.data.results.filter(f => f.enabled && f.mode.includes(1))
          if (domain.length > 0) {
            this.customDomainURL = `wasap.${domain[0].name}`
          }
        })
        .catch(() =>{})
    },
    fetchZones () {
      this.$axios.get(`/shipping/settings/${this.company.slug}/zones/?page_size=-1`)
        .then((response) => {
          if (response.data.results) {
            this.zones = response.data.results
          }
        }).catch(() => {})
    },
    getFormURL () {
      return `https://${this.company.slug}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.form.slug}`
    },
    getShareLinkURL () {
      return `WhatsApp Now: ${this.linkURL + this.form.slug}`
    },
    getBrandedLinkURL () {
      return this.linkURL + this.form.slug
    },
    getShareLinkFB () {
      return this.linkURL + this.form.slug
    },
    getShortLinkURL () {
      return `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.form.slug}`
    },
    getQRLinkURL () {
      return this.linkURL + this.form.slug
    },
    getShareCustomURL () {
      return this.linkURL + this.customlinkSlug
    },
    openLink (link) {
      window.open(link)
    },
    clickShare () {
      if (this.form.status === 'published') {
        this.shareSheet = true
      } else {
        this.generatingShareUrl = true
        setTimeout(() => {
          this.generatingShareUrl = false
          this.showMessage(['error', this.$t('error_message.please_publish_this_form')])
          this.shareSheet = false
        }, 2000)
      }
    },
    copyUrl (ref, text) {
      let container = this.$refs[ref]
      this.$copyText(text, container)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
          this.shareSheet = false
        })
    },
    shareUrlToSocial (platform) {
      if (platform == 'whatsapp') {
        window.open(`https://api.whatsapp.com/send?text=${this.getShareLinkURL()}`, '_blank')
      } else if (platform == 'facebook') {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.getShareLinkFB()}`, '_blank')
      } else if (platform === 'twitter' ) {
        window.open(`http://twitter.com/share?url=${encodeURIComponent(this.getShareLinkURL())}`, '_blank')
      }
    },
    closeEdit () {
      if (this.form.members.length === 0 || this.form.products.length === 0) {
        this.form.created = this.parentForm.created
      }
      this.$emit('update:parentForm', this.form)
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "edit_sales_page": "Edit Sales Page",
    "edit_link": "Edit link",
    "customize_your_page": "Customize your page",
    "edit_page_content": "Edit page content",
    "data_collection": "Data collection",
    "products_and_order": "Products & orders",
    "what_customer_can": "What customers can do",
    "whos_selling": "Who's selling",
    "manage_shipping_zones": "Manage shipping zones",
    "share_url_by": "Share url by",
    "whatsapp": "WhatsApp",
    "facebook": "Facebook",
    "copy_custom_link": "Copy Custom Link",
    "copy_link": "Copy Link",
    "copy_short_link": "Copy Short Link",
    "print_qr_code": "Print QR Code",
    "generation_share_url": "Generating share url..."
  },
  "id": {
    "edit_sales_page": "Edit Penjualan",
    "edit_link": "Edit Tautan",
    "customize_your_page": "Sesuaikan halaman kamu",
    "edit_page_content": "Edit halaman konten",
    "data_collection": "Koleksi Data",
    "products_and_order": "Produk & pesanan",
    "what_customer_can": "Apa yang dapat dilakukan pelanggan",
    "whos_selling": "Penjual",
    "manage_shipping_zones": "Mengatur wilayah pengiriman",
    "share_url_by": "Bagikan URL ke:",
    "whatsapp": "WhatsApp",
    "facebook": "Facebook",
    "copy_custom_link": "Copy Custom Link",
    "copy_link": "Salin Tautan",
    "copy_short_link": "Salin Tautan Pendek",
    "print_qr_code": "Print QR Code",
    "generation_share_url": "Memproses bagikan URL..."
  }
}
</i18n>
